import type { FC } from 'react';

import type { ModalComponent } from '../../types';

import { Markdown } from '@snowit/ui';

import Modal from '../Modal/Modal';

const ModalMessage: FC<ModalComponent> = (props: ModalComponent) => {
  const { body, size = 'df' } = props;

  const renderBodyContent = () => {
    const bodyContent = typeof body === 'function' ? body() : body || '';

    if (typeof bodyContent === 'string') {
      return <Markdown source={bodyContent} />;
    }

    return bodyContent;
  };

  return (
    <Modal
      {...props}
      classNames={{
        ...props.classNames,
      }}
      body={renderBodyContent}
      theme={'error'}
      size={size}
    />
  );
};

export default ModalMessage;
